var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8 flex-1 h-0 overflow-y-auto text-xl md:text-base"},[_c('nav',{staticClass:"px-4 space-y-2 md:space-y-1"},_vm._l((_vm.items),function(item){return _c('page-link',{key:item.label,class:[
				'relative group flex items-center px-3 py-2 text-white font-medium rounded-2xl cursor-pointer',
				_vm.isActive(item)
					? 'md:bg-green bg-green-600 md:text-white'
					: 'hover:bg-green-600 md:hover:bg-gray-100 md:hover:text-gray-700',
					item.premiumRequired || item.disabled && !_vm.isActive(item)
					? 'md:text-gray-300'
					: 'md:text-gray-700'
			],attrs:{"href":item.href,"acl":item.acl_soft,"cta":{
				code: 402,
				view: 'views/Modal/PremiumRequired'
			},"absolute":true}},[_c('ui-icon',{class:[
					'mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-inherit',
					// isActive(item) ? '' : 'md:text-gray-600',
					// item.highlight && !isActive(item) ? 'md:text-gray-300' : ''
				],attrs:{"name":item.icon,"stroke-width":"2","classes":item.classes}}),_vm._v("\n\t\t\t"+_vm._s(_vm.__(item.label))+"\n\t\t\t"),(item.premiumRequired)?_c('span',{staticClass:"ml-1 -mt-2"},[_vm._v("+")]):_vm._e(),_vm._v(" "),(item.count)?_c('span',{staticClass:"ml-3 inline-flex shadow-md md:shadow-none items-center justify-center px-3 py-2 md:px-2 md:py-1 text-base md:text-xs font-bold leading-none text-white transform bg-orange rounded-full"},[_vm._v(_vm._s(item.count))]):_vm._e()],1)}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }